// localStorage under a per-playground prefix. Private mode: edits last for
// this visit only.

export function createStore( prefix ) {

	return {
		get( key ) {

			try {

				return localStorage.getItem( prefix + key );

			} catch {

				return null;

			}

		},
		set( key, value ) {

			try {

				if ( value == null ) localStorage.removeItem( prefix + key );
				else localStorage.setItem( prefix + key, value );

			} catch { /* private mode */ }

		},
	};

}
